import React from 'react'

const PL3 = (props) => {
    console.log(props)
    let tapBeers = props.tapMenu.sections[0].items
    let canBeers = props.canMenu.sections[0].items
    let bottleBeers = props.canMenu.sections[1].items
    
    const processPrice = (price) => {
        let integer = parseFloat(price)
        console.log(price)
        console.log(integer)
        let updated = parseFloat(integer.toFixed(4))
        return updated
    }

    return (
        <div className="taps-can-page">
            <div className="background-image">
                <div className="col-left">
                    <div className="column pl3-taps-cans-pg-left">
                        {tapBeers.map(item => (
                            <div className="pl3-tap-item-page tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{processPrice(item.containers[0].price)}</span>
                                    <div className="print-item-line-two pl3">{item.containers[0].name} • <span className="style-print"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="col-right">
                    <div className="column pl3-taps-cans-pg-right">
                        {canBeers.map(item => (
                        <div className="pl3-can-item-page tap-item-print">
                                {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{processPrice(item.containers[0].price)}</span>
                                <div className="print-item-line-two pl3 cans">{item.containers[0].name} • <span className="style-print-can pl1"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                        </div>
                        ))}
                        {bottleBeers.map(item => (
                        <div className="pl3-can-item-page tap-item-print">
                                {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{processPrice(item.containers[0].price)}</span>
                                <div className="print-item-line-two pl3 cans">{item.containers[0].name} • <span className="style-print-can pl1"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PL3